import { CouponEventContainerModel } from "../../../../../../models/aggregates/erp/coupon";
import {
  ApiVisa,
  BaseApiTemplateService,
  Core2Config,
  PagingResponseModel,
} from "../../shared";
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import {
  CouponEventQueryCriteriaClass,
  CouponEventCriteriaModelQuery,
} from "../../../criteria/coupon-event-criteria.model";

@Injectable({ providedIn: "root" })
export class CouponEventService extends BaseApiTemplateService<CouponEventContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl =
      Core2Config.DOMAIN_URL +
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      "coupon/events";
    this.endpoint_path =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      "coupon/events";
    this.httpClient = http;
  }

  getCouponEventByCriteria(
    visa: ApiVisa,
    criteria?: CouponEventQueryCriteriaClass
  ): Observable<PagingResponseModel<CouponEventContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const buildCouponEventCriteriaCriteria =
      new CouponEventCriteriaModelQuery(criteria);
    console.log("query", buildCouponEventCriteriaCriteria.query);
    return this.httpClient.get<
      PagingResponseModel<CouponEventContainerModel>
    >(
      this.apiUrl + "/query?" + buildCouponEventCriteriaCriteria.query,
      this.getHttpHeader(visa)
    );
  }
}
